module.exports = __webpack_public_path__ + "static/media/300_7.99ad042c.jpg";